import React, { useEffect, useState } from 'react'
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import LoginHeader from '../../components/header/LoginHeader';
import Banner01 from '../../components/banner/Banner01';
import Category from "../../components/category";
import Job03 from '../../components/jobs/Job03';
import Box07 from '../../components/boxicon/Box07';
import Couter from "../../components/iconbox/Couter";
import Blog01 from '../../components/blog/Blog01';
import Partner from '../../components/partner';
import Footer from '../../components/footer';
import Gotop from '../../components/gotop';
import dataEm from '../../assets/fakeData/dataEmployers';
import dataBlog from '../../assets/fakeData/dataBlog';
import dataPartner from '../../assets/fakeData/dataPartner';
import dataCate from '../../assets/fakeData/dataCategory';
import Employer from '../../components/employer';
import CRHeader from '../../components/header/CRHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';
import TopCandidates from '../TopCandidates/TopCandidates';
import Banner07 from '../../components/banner/Banner07';

const CRhomepage = () => {
    const [isShowMobile, setShowMobile] = useState(false);
    const handleMobile = () => {
      const getMobile = document.querySelector(".menu-mobile-popup");
      setShowMobile(!isShowMobile);
      !isShowMobile
        ? getMobile.classList.add("modal-menu--open")
        : getMobile.classList.remove("modal-menu--open");
    };
  
    useEffect(() => {
      const WOW = require("wowjs");
      window.wow = new WOW.WOW({
        live: false,
      });
      window.wow.init();
    }, []);
  
    return (
      <>
        <CRMobileHeader handleMobile={handleMobile} />
        <CRHeader clname="act1" handleMobile={handleMobile} />
        <div className="pt-120 pb-5">
        <Banner07 />
        </div>
        <Category data={dataCate} /> 
        <TopCandidates className="pt-3 pb-3"/> 
        <Partner data={dataPartner} />    
        <Footer />
        <Gotop />
      </>
    )
    
}

export default CRhomepage